import axios from "axios";
import { logDetailed } from "../../helpers/utils";
import {
  setupRefreshTokenLoop, setupAutologoutEvents, disableAutologoutEvents,
  disableRefreshTokenLoop
} from "../../helpers/idle";
import { disableRefreshPatientLoop } from "../../helpers/patientRefresh";

export const login = ({ commit, dispatch }, payload) =>
  processLogin(commit, dispatch, "/api/account/signin", payload);

export const sso = ({ commit, dispatch, getters }, payload) => {
  if (getters.allowUISSO) {
    payload.fullURL = window.location.href;
    mergePidKey(payload, "pid");
    mergePidKey(payload, "ptid");
    return processLogin(commit, dispatch, "/api/account/sso", payload);
  }
  else return Promise.reject();
};

function mergePidKey(payload, pattern) {
  var objKey = Object.keys(payload).find(key => key.toLowerCase() === pattern);
  if (objKey) {
    let temp = payload[objKey];
    delete payload[objKey];
    payload.ptID = temp;
  }
}

function processLogin(commit, dispatch, url, payload) {
  logDetailed("actions", "processLogin");
  return axios.post(url, payload)
    .then(response => {
      logDetailed("actions", "processLogin", "post succeeded");
      disableRefreshTokenLoop();
      disableAutologoutEvents();
      commit("updateAuth", response.data);
      return Promise.resolve(response.data);
    })
    .then(loginData => {
      dispatch("getUserPrefs");
      dispatch("ensureStaticListsLoaded", true)
        .then(() => {
          setupRefreshTokenLoop();
          setupAutologoutEvents();
        });
      return Promise.resolve(loginData);
    })
    .catch(error => {
      logDetailed("actions", "processLogin", "post failed");
      return logoutAndReject(dispatch, error);
    })
}

export const emrStatLogin = ({commit, dispatch}, payload) => {
  mergePidKey(payload, "pid");
  mergePidKey(payload, "ptid");
  return processEMRstatLogin(commit, dispatch, "/api/account/sso", payload);
}

function processEMRstatLogin(commit, dispatch, url, payload){
  logDetailed("actions", "processEMRstatLogin");
  return axios.post(url, payload)
    .then(response =>{
      logDetailed("actions", "processEMRstatLogin", "post succeeded");
      commit("updateAuth", response.data);
      disableAutologoutEvents();
      return Promise.resolve(response.data)
    })
    .catch(error => {
      logDetailed("actions", "processEMRstatLogin", "post failed");
      return logoutAndReject(dispatch, error);
    })
}

export const validateJWT = ({ commit, dispatch }, query) => {
  if (!query || !query.data)
    return Promise.reject("Missing json payload");

  let data = JSON.parse(query.data);
  if (!data.access_token || !data.refresh_token || !data.user)
    return Promise.reject("Missing required jwt data in json payload");

  logDetailed("actions", "validateJWT", "handling jwt login", query);

  commit("updateAuth", data);
  return dispatch("isTokenExpired")
    .then(() => dispatch("renewToken"))
    .then(() => {
      dispatch("ensureStaticListsLoaded", true)
        .then(() => {
          setupRefreshTokenLoop();
          setupAutologoutEvents();
        });
      return Promise.resolve();
    })
    .catch(error => {
      logoutAndReject(dispatch, error);
    });
};

function logoutAndReject(dispatch, error) {
  dispatch("logout");
  return Promise.reject(error && error.response);
}

export const renewToken = ({ commit }) => {
  logDetailed("actions", "renewToken");
  const auth = sessionStorage.getItem("auth");
  const json = JSON.parse(auth);
  const refreshToken = (json && json.auth && json.auth.refresh_token) ? json.auth.refresh_token : "";
  return axios
    .post("/api/token/renewtokens", {
      RefreshToken: refreshToken
    })
    .then(response => {
      logDetailed("actions", "renewToken", "post succeeded");
      commit("updateAuth", response.data);
    })
    .catch(error => {
      logDetailed("actions", "renewToken", "post failed");
      return Promise.reject(error && error.response);
    });
}


export const isTokenExpired = ({ dispatch }) => {
  axios.post("/api/token/tokenAlive")
    .catch(error => logoutAndReject(dispatch, error));
}

export const logout = ({ commit, dispatch }) => {
  logDetailed("actions", "logout");
  axios.post("/api/account/logout");
  disableAutologoutEvents();
  disableRefreshTokenLoop();
  disableRefreshPatientLoop();
  commit("setUserPrefs", []);
  commit("resetCalledFullscreenToggle");
  dispatch("clearAllDialogs")
    .finally(() => commit("logout"));
};

export const clearAllDialogs = ({ commit }) => {
  logDetailed("actions", "clearAllDialogs");
  commit("setTextAnnotationToEdit", null);
  commit("clearBrowserContext");
  commit("clearOverlay");
  commit("clearStereoContext");
  commit("clearPrintPreviewContext");
  commit("cancelDeleteImages");
  commit("clearProofsheetContext");
  commit("clearPatientExamMultiviewContext");
  commit("clearSelectedPatient");
  commit("setExamToDelete", null);
  commit("clearExamDeleteList");
  commit("clearEditExam");
  commit("setLoadingMessage", null);
  commit("closeHelpDialog");
  return Promise.resolve();
}

export const getMFAEnabled = ({ commit }) =>
  axios.post("/api/account/getmfa")
    .then(response => commit("set2faEnabled", response.data));

export const setMFAEnabled = (_, payload) =>
  axios.post("/api/account/setmfa", payload);

export const setMFASecret = (_, payload) =>
  axios.post("/api/account/setmfasecret", payload);

export const getMFASecret = () =>
  axios.post("/api/account/getmfasecret");